<template>
  <div class="w-full h-full overflow-auto" v-loading="formLoading">
    <div class="pt-20px">
      <div class="step_box flex">
        <div class="step_line_box w-24px relative">
          <div class="w-2px top-0 !bottom-0 absolute left-7px bg-[#19626E]"></div>
          <div
            class="w-16px h-16px rounded-full relative z-1 f_bg  flex items-center justify-center"
          >
            <div class="w-6px h-6px bg-[#FF8900]  rounded-full"></div>
          </div>
        </div>
        <div class="flex-auto ml-4px relative content_relative">
          <div class="flex justify-between">
            <!-- bg-[#1F737F] -->
            <div
              class="w-93px h-29px text-white font-bold text-14px flex items-center justify-center bg_title_img"
            >
              事件信息
            </div>
            <div class="flex text-white" v-if="formData.status === 2">
              <button
                class="mr-6px handle_btn"
                @click="openDialog"
                :disabled="!(formData.disposalUsers && formData.disposalUsers.includes(userId))"
              >
                响应升级
              </button>
              <button
                class="handle_btn"
                @click="handleEnd"
                :disabled="!(formData.disposalUsers && formData.disposalUsers.includes(userId))"
              >
                响应终止
              </button>
            </div>
          </div>
          <div class="first_step_content_box">
            <div class="flex">
              <span>事件名称：</span><span class="flex-auto w-0">{{ formData.name }}</span>
            </div>
            <div class="flex">
              <span>事件类型：</span><span class="flex-auto w-0">{{ formData.categoryText }}</span>
            </div>
            <div class="flex">
              <span>风险等级：</span
              ><span class="text-[#FC0F0F] flex-auto w-0">{{ formData.level }}</span>
            </div>
            <div class="flex">
              <span>事故区域：</span
              ><span class="flex-auto w-0"
                >{{ formData.siteText }}
                <!-- <i
                  class="ml-7px text-[#FC8403] iconfont icon-bg-localtion text-12px cursor-pointer"
                ></i> -->
              </span>
            </div>
            <div class="flex">
              <span>事件时间：</span
              ><span class="flex-auto w-0">{{
                formData.occurTime ? dayjs(formData.occurTime).format('YYYY-MM-DD HH:mm:ss') : ''
              }}</span>
            </div>
            <div class="flex">
              <!-- 后台暂无等级转译 -->
              <!-- text-[#FC0F0F] -->
              <span>响应等级：</span
              ><span class="text-[#FC0F0F] flex-auto w-0">{{ formData.responseLevelText }}</span>
            </div>
            <div class="flex">
              <span>应急预案：</span
              ><span class="text-hex-00bcc8 cursor-pointer flex-auto w-0" @click="reviewDetail">{{
                formData.enablePlanName
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="step_box flex">
        <div class="step_line_box w-24px relative">
          <div class="w-2px top-0 !bottom-0 absolute left-7px bg-[#19626E]"></div>
          <div
            class="w-16px h-16px rounded-full relative z-1 f_bg  flex items-center justify-center"
          >
            <div class="w-6px h-6px bg-[#FF8900] rounded-full"></div>
          </div>
        </div>
        <div class="flex-auto ml-4px relative content_relative">
          <div class="flex justify-between">
            <div
              class="w-93px h-29px text-white font-bold text-14px flex items-center justify-center bg_title_img"
            >
              应急救援调度
            </div>
          </div>
          <div class="second_step_content_box">
            <div
              class="w-85px h-60px  bg-[#1F737F] mb-10px flex flex-col justify-center items-center"
            >
              <span class="text-hex-00bcc8">{{ personCount }}</span>
              <div class="text-white">救援人员</div>
            </div>
          </div>
        </div>
      </div>
      <div class="step_box flex">
        <div class="step_line_box w-24px relative">
          <div class="w-2px top-0 !bottom-0 absolute left-7px bg-[#19626E]"></div>
          <div
            class="w-16px h-16px rounded-full relative z-1 f_bg  flex items-center justify-center"
          >
            <div class="w-6px h-6px bg-[#FF8900]  rounded-full"></div>
          </div>
        </div>
        <div class="w-0px flex-1 ml-4px relative content_relative">
          <div class="flex justify-between">
            <div
              class="w-93px h-29px text-white font-bold text-14px flex items-center justify-center bg_title_img"
            >
              应急态势
            </div>
          </div>
          <div class="third_step_content_box">
            <tableButtonGroup v-model="activeTab" :list="tabList" @btn-click="btnClick" />
            <template v-if="activeTab.includes('疏散人群')">
              <el-table
                class="w-full"
                :data="personTableData"
                highlight-current-row
                height="300px"
                ref="tableRef"
                v-loading="personTableLoading"
              >
                <el-table-column label="人员" prop="name" show-overflow-tooltip />
                <!-- <el-table-column label="目标位置" prop="codeStr" show-overflow-tooltip>
                  <template slot-scope="{ row }">
                    {{ formData.evacuateSafetys | safetysText }}
                  </template>
                </el-table-column> -->
                <el-table-column label="目标位置" prop="safetyIslandName" show-overflow-tooltip>
                </el-table-column>
                <el-table-column label="是否到达" prop="isTodo" show-overflow-tooltip>
                  <template slot-scope="{ row }">
                    <span
                      class="cursor-pointer"
                      :class="row.isTodo ? 'text-[#FCOFOF]' : 'text-[#45D656]'"
                      >{{ row.isTodo | isTodoText }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="60px">
                  <template slot-scope="{ row }">
                    <i
                      @click="handleDetail(row)"
                      class="ml-7px text-[#FC8403] iconfont icon-bg-localtion text-12px cursor-pointer"
                    ></i>
                  </template>
                </el-table-column>
              </el-table>
              <v-chart
                :options="personnelChartOptions"
                autoresize
                class="w-full h-200px"
                ref="alarmTrend"
              ></v-chart>
            </template>
            <template v-if="activeTab.includes('应急报警')">
              <div class="statistics_san mt-10px">
                <table
                  v-loading="personTableLoading"
                  border="none"
                  cellpadding="0"
                  cellspacing="0"
                  class="table_bei"
                >
                  <tbody clsss="tBody" v-if="alarmTableData && alarmTableData.length > 0">
                    <tr
                      v-for="(item, index) in alarmTableData"
                      :key="index"
                      :class="item.alarmRemoveType === 0 ? 'iswarn_table_tr' : 'table_tr'"
                    >
                      <td
                        class="w-full h-full text-left px-5px flex items-center"
                        :title="item.name"
                      >
                        <img
                          v-if="item.alarmRemoveType === 0"
                          src="../../../assets/images/carousel_alarm_icon.png"
                        />
                        <div v-else class="w-25px"></div>
                        <div class="flex-auto">{{ item.personNames }}二</div>
                      </td>
                      <td class="w-3/12 text-left px-5px break-all" :title="item.name">
                        {{ item.name }}
                      </td>
                      <td class="w-4/12 text-left px-5px" :title="item.eventStartTime">
                        {{ item.eventStartTime }}
                      </td>
                      <td
                        class="w-2/12 text-right text-[#00d1ff] px-5px cursor-pointer"
                        @click="dealAlarm(item)"
                      >
                        <span v-if="item.alarmRemoveType === 0">
                          处理
                        </span>
                      </td>
                    </tr>
                  </tbody>
                  <div v-else class="w-full h-120px flex justify-center items-center">
                    <img src="../../../assets/images/no_data@1x.png" alt="" />
                  </div>
                </table>
              </div>
              <v-chart
                :options="alarmChartOptions"
                autoresize
                class="w-full h-200px"
                ref="alarmTrend"
              ></v-chart>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  SuppliesTypeApi,
  SuppliesManagementApi,
  SuppliesSiteApi,
  AccidentEventsResponseRecordingApi,
  AccidentEventsResponseDisposeApi,
  AccidentEventsResponse3DApi,
  PlanApi,
  AccidentEventsResponse3DAlarmStatisticsApi,
  AccidentEventsResponseRescueDispatchApi,
} from '@wiz-api/emergency-management'

import { isEmpty, flatten, map, cloneDeep, filter, some, isNil } from 'lodash'
import { StandardAlarmRecordApi } from '@wiz-api/personnel-position'
import dayjs from 'dayjs'
import TableButtonGroup from '@/components/cockpit/TableButtonGroup'
import bus from './bus'

const alarmRecordApi = new StandardAlarmRecordApi()

const accidentEventsResponseDisposeApi = new AccidentEventsResponseDisposeApi()
const suppliesManagementApi = new SuppliesManagementApi()
const suppliesTypeApi = new SuppliesTypeApi()
const accidentEventsResponseRecordingApi = new AccidentEventsResponseRecordingApi()
const accidentEventsResponse3DApi = new AccidentEventsResponse3DApi()
const accidentEventsResponse3DAlarmStatisticsApi = new AccidentEventsResponse3DAlarmStatisticsApi()
const accidentEventsResponseRescueDispatchApi = new AccidentEventsResponseRescueDispatchApi()
const planApi = new PlanApi()
export default {
  components: {
    TableButtonGroup,
  },
  filters: {
    isTodoText(value) {
      if (value === true) {
        return '已到达'
      }
      if (value === false) {
        return '未到达'
      }
      return ''
    },
    safetysText(values) {
      if (values && values.legend) {
        return values
          .map((item) => {
            return item.name
          })
          .join()
      }
      return ''
    },
  },
  data() {
    return {
      personCount: 0,
      activeTab: '疏散人群',
      tabList: ['疏散人群', '应急报警'],
      // activeTab: '应急报警',
      // tabList: ['应急报警'],

      typeList: [],
      personTableData: [],
      alarmTableData: [],
      tableLoading: false,
      personTableLoading: false,
      alarmTableLoading: false,
      pageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      searchData: {},
      total: 0,
      metalBimBaseData: {},

      personnelChartOptions: {
        grid: {
          top: 50,
          left: 40,
          right: 20,
          bottom: 20,
        },
        xAxis: {
          type: 'category',
          data: [dayjs().format('HH:mm:ss')],
          axisLabel: {
            color: 'rgba(255,255,255,0.6)',
            fontSize: 12,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: 'rgba(255,255,255,0.6)',
            fontSize: 12,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.1)',
            },
          },
          padding: [0, 50, 0, 0],
          fontSize: 10,
        },
        legend: {
          show: true,
          top: 'top',
          data: ['疏散人群', '已到达', '未到达'],
          textStyle: {
            color: 'rgba(255,255,255,0.7)',
            fontSize: 12,
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        color: ['rgba(34,118,252,1)', 'rgba(95,213,236,1)', '#ED3636'],
        series: [
          {
            name: '疏散人群',
            data: [0],
            type: 'line',
            smooth: true,
          },
          {
            name: '已到达',
            data: [0],
            type: 'line',
            smooth: true,
          },
          {
            name: '未到达',
            data: [0],
            type: 'line',
            smooth: true,
          },
        ],
      },
      alarmChartOptions: {
        grid: {
          top: 50,
          left: 40,
          right: 20,
          bottom: 20,
        },
        xAxis: {
          type: 'category',
          data: [dayjs().format('YYYY-MM-DD HH:mm:ss')],
          axisLabel: {
            color: 'rgba(255,255,255,0.6)',
            fontSize: 12,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: 'rgba(255,255,255,0.6)',
            fontSize: 12,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.1)',
            },
          },
          padding: [0, 50, 0, 0],
          fontSize: 10,
        },
        legend: {
          show: true,
          top: 'top',
          data: ['报警总数', '已消警', '报警中'],
          textStyle: {
            color: 'rgba(255,255,255,0.7)',
            fontSize: 12,
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        color: ['rgba(34,118,252,1)', 'rgba(95,213,236,1)', '#ED3636'],
        series: [
          {
            name: '报警总数',
            data: [0],
            type: 'line',
            smooth: true,
          },
          {
            name: '已消警',
            data: [0],
            type: 'line',
            smooth: true,
          },
          {
            name: '报警中',
            data: [0],
            type: 'line',
            smooth: true,
          },
        ],
      },
      btnValue: '日',
      formData: {},
      formLoading: false,
      status: '',
      ws: '',
      onlineTagList: [],
      // 后台获取的时间
      realTime: null,

      alarmTimer: null,

      isReal: false,
    }
  },
  created() {
    this.getType()
    // this.openWebSocketClient()
    const str = sessionStorage.getItem('onlineTagList')
    this.onlineTagList = str ? JSON.parse(str) : []
    // this.getPersonTableData()

    // this.findListAlarm()

    window.addEventListener('refreshAlarmList', this.findListAlarm)
  },
  computed: {
    modelSetting() {
      return Wiz.globalSettings.dynamicModules.modules['visualization-cockpit-tongre'].config
    },
  },
  methods: {
    async reviewDetail() {
      const [err, res] = await planApi.getPlan({
        id: this.formData.enablePlanId,
      })
      // enablePlanId 没有返回类型根据id去拿类型
      if (!err) {
        bus.$emit('translate', {
          row: {
            id: this.formData.enablePlanId,
            name: this.formData.enablePlanName,
            typeName: res.plan.typeName,
          },
          type: 'plan',
        })
      }
    },
    dealAlarm(row) {
      const openEvent = new CustomEvent('openEmergencyDisposalDialog', {
        detail: {
          row,
          type: 'dealAlarm',
        },
      })
      window.dispatchEvent(openEvent)
    },
    btnClick(value) {
      // if (value.includes('疏散人群')) {
      //   this.findListPerson()
      // }
      // if (value.includes('应急报警')) {
      //   this.findListAlarm()
      // }
    },
    async getPersonTableData() {
      const [err, res] = await accidentEventsResponse3DApi.userAreaFilter({
        accidentAearId: this.formData.site,
        accidentRecordingId: row.id,
      })
    },
    openWebSocketClient() {
      if (this.ws) {
        this.ws.close()
      }
      const socketUrl =
      `${this.modelSetting?.emergencyDisposalConfig.webSocketUrl}/Position?modelId=3a0f5919-b640-f2f2-30e6-323c5865e1d3&siteId=3a0743fd-2f61-51c2-3bfd-415e973ef230`
      // 'ws://devaspnetcore02.wiz.top:4547/Position?modelId=3a0f5919-b640-f2f2-30e6-323c5865e1d3&siteId=3a0743fd-2f61-51c2-3bfd-415e973ef230'
      this.ws = new WebSocket(socketUrl)

      // ws.readyState===0 正在建立连接还没有连接
      // ws.readyState===1 连接成功，可以send数据
      // ws.readyState===2 正在关闭，还没有关闭
      // ws.readyState===3 连接已关闭，或不能打开
      // 监听连接是否成功
      this.ws.onopen = () => {}
      // 接收服务器信息
      this.ws.onmessage = (data) => {
        const msg = JSON.parse(data.data)
        // this.realData = msg.positionList || []
      }
      // 监听连接关闭时间
      this.ws.onclose = () => {}
      // 监听并处理错误事件
      this.ws.onerror = (error) => {
        if (this.ws.readyState === 3) {
          this.$message.error('无法获取人员实时信息')
        }
      }
    },
    async handleEnd() {
      this.$confirm('请确认是否终止响应？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        lockScroll: false,
      })
        .then(async () => {
          const [err, res] = await accidentEventsResponseDisposeApi.responseAborted({
            body: {
              id: this.formData.id,
            },
          })
          if (!err) {
            this.$message({
              showClose: true,
              message: '响应终止成功',
              type: 'success',
            })
            // 终止后关闭面板刷新列表
            const openEvent = new CustomEvent('controlCenterClose', {})
            window.dispatchEvent(openEvent)
          }
        })
        .catch(() => {})
    },
    openDialog() {
      const openEvent = new CustomEvent('openEmergencyDisposalDialog', {
        detail: {
          row: this.formData,
          type: 'upLevel',
        },
      })
      window.dispatchEvent(openEvent)
    },
    handleDetail(row) {},
    async findListPerson() {
      // 需求更改暂时屏蔽等待接口
      // return
      this.personTableLoading = true
      const data = {
        accidentRecordingId: this.formData.id,
        isStartupRealTime: this.isReal,
        maxResultCount: 999, // 每页多少条
        skipCount: 0, // 跳过多少条
      }
      const [err, res] = await accidentEventsResponse3DApi.getEvacuatePersonnels(data)
      if (!err) {
        this.personTableData = res.items
        this.total = res.totalCount

        const tabList = JSON.parse(JSON.stringify(this.tabList))
        tabList[0] = `疏散人群（${res.totalCount}）`
        this.tabList = tabList
      }
      this.personTableLoading = false
    },
    async findListPersonChart() {
      // 需求更改暂时屏蔽等待接口
      // return
      this.personTableLoading = true
      const data = {
        accIdentRecordId: this.formData.id,
        isStartupRealTime: this.isReal,
        maxResultCount: 5, // 每页多少条
        skipCount: 0, // 跳过多少条
      }
      const [err, res] = await accidentEventsResponse3DApi.getEvacuatePersonnelStatistics(data)
      if (!err) {
        this.dealPersonChart(res.items)
      }
      this.personTableLoading = false
    },
    async findListAlarm() {
      this.alarmTableLoading = true
      // alarmRemoveType: 0,
      const data = {
        areaId: this.formData.site,
        maxResultCount: 999, // 每页多少条
        skipCount: 0, // 跳过多少条
        startTime:
          this.formData.status === 2
            ? dayjs(this.formData.responseStartTime).format('YYYY-MM-DD HH:mm:ss')
            : dayjs().format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      }
      // const [err, res] = await alarmRecordApi.getList(data)
      const [err, res] = await accidentEventsResponse3DApi.getStandardAlarmRecordPageList(data)

      if (!err) {
        this.alarmTableData = res.items.map((item) => {
          return {
            ...item,
            eventStartTime: dayjs(item.eventStartTime).format('YYYY-MM-DD HH:mm:ss'),
            name: item.personNames + item.alarmTypeName + item.fenceName,
          }
        })
        this.total = res.totalCount
        const tabList = JSON.parse(JSON.stringify(this.tabList))
        tabList[1] = `应急报警（${res.totalCount}）`
        this.tabList = tabList
      }
      this.alarmTableLoading = false
    },
    // 获取物资类型
    async getType() {
      const params = {
        skipCount: 0,
        maxResultCount: 99,
      }
      const [err, data] = await suppliesTypeApi.getList(params)
      if (!err) {
        this.typeList = data.items
      }
    },
    // 应急报警图表实时数据
    async findListAlarmChart() {
      if (!this.realTime) return
      const [err, res] = await accidentEventsResponse3DAlarmStatisticsApi.getAlarmStatistics({
        accIdentRecordId: this.formData.accidentId,
        startTime: this.realTime,
      })
      if (!err) {
        this.dealAlarmChart(res)
      }
    },
    dealPersonChart(list) {
      if (!(list && list.length)) return
      const personnelChartOptions = JSON.parse(JSON.stringify(this.personnelChartOptions))
      const totalCount = [] // 疏散人群
      const arrivedCount = [] // 已达目标位置
      const notArrivedCount = [] // 未达目标位置
      const xData = [] // 横坐标时间

      list.reverse().forEach((item) => {
        totalCount.push(item.totalCount)
        arrivedCount.push(item.arrivedCount)
        notArrivedCount.push(item.notArrivedCount)
        // xData.push(dayjs(item.totalTime).format('YYYY-MM-DD HH:mm:ss'))
        xData.push(dayjs(item.totalTime).format('HH:mm:ss'))
      })
      personnelChartOptions.series[0].data = totalCount
      personnelChartOptions.series[1].data = arrivedCount
      personnelChartOptions.series[2].data = notArrivedCount
      personnelChartOptions.xAxis.data = xData
      this.personnelChartOptions = personnelChartOptions
    },
    dealAlarmChart(list) {
      if (!(list && list.length)) return
      const alarmChartOptions = JSON.parse(JSON.stringify(this.alarmChartOptions))
      const alarmTotalData = [] // 报警总数数据
      const cancelAlarmCountData = [] // 已消警数据
      const alarmIngCountData = [] // 报警中数据
      const xData = [] // 横坐标时间
      list.forEach((item) => {
        alarmTotalData.push(item.alarmTotal)
        cancelAlarmCountData.push(item.cancelAlarmCount)
        alarmIngCountData.push(item.alarmIngCount)
        xData.push(dayjs(item.totalTime).format('YYYY-MM-DD HH:mm:ss'))
      })
      alarmChartOptions.series[0].data = alarmTotalData
      alarmChartOptions.series[1].data = cancelAlarmCountData
      alarmChartOptions.series[2].data = alarmIngCountData
      alarmChartOptions.xAxis.data = xData
      this.alarmChartOptions = alarmChartOptions
    },
    // 应急报警图表获取历史数据
    async findListAlarmCharttHistory() {
      const [err, res] = await accidentEventsResponse3DAlarmStatisticsApi.getAlarmStatistics({
        accIdentRecordId: this.formData.accidentId,
      })
      if (!err) {
        if (res.length) {
          this.realTime = res[res.length - 1].totalTime
        }
        // 处置没结束已实时数据为准
        if (this.formData.status === 3) {
          this.findListAlarmChart()
        } else {
          this.dealAlarmChart(res)
        }
      }
    },
    async getCount(row) {
      const [err, res] = await accidentEventsResponseRescueDispatchApi.getCount({
        enabledToTalCount: true,
        accidentRecordingId: row.id,
      })
      if (!err) {
        this.personCount = res.totalCount
      }
    },
    async getData(row) {
      // 2为处置中3为已经终止
      this.formLoading = true
      const [err, res] = await accidentEventsResponse3DApi.get3DBaseInfo({
        accidentId: row.accidentId,
        accidentRecordingId: row.id,
      })
      // res.accidentId = '3a106bda-321c-06e3-b429-56e967a438ae' // 写死测试接口
      if (!err) {
        res.status = row.status
        this.formData = res
        // 应急报警
        this.findListAlarm()
        // 应急报警图例
        this.findListAlarmCharttHistory()
        if (this.formData.status === 2) {
          this.isReal = true
          window.addEventListener('onlineTagList', this.getTimerPerson)
          // 如果在处置中定时更新数据
          if (!this.alarmTimer) {
            this.alarmTimer = setInterval(this.getTimerAlarm, 60000)
          }
        } else {
          this.isReal = false
        }
        // 疏散人群列表
        this.findListPerson()
        // 疏散人群图例
        this.findListPersonChart()
      }
      this.formLoading = false
    },
    getTimerPerson() {
      this.findListPerson()
      this.findListPersonChart()
    },
    getTimerAlarm() {
      this.findListAlarm()
      this.findListAlarmChart()
    },
  },
  destroyed() {
    if (this.alarmTimer) {
      clearInterval(this.alarmTimer)
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 80px)'
    },
    userId() {
      // 获取用户信息，dev环境需要copy到public/config/setting.json,以便拿去本地信息
      const userInfo = Wiz.AuthHooks.GetUserInfo()
      const { sub } = userInfo?.profile
      return sub
    },
  },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {},
    },
  },
  watch: {
    transferProps: {
      handler(data) {
        this.getData(data)
        this.getCount(data)
      },
      deep: true,
      immediate: true,
    },
    tabList(value) {
      this.activeTab = value.find((str) => {
        return str.includes(this.activeTab.slice(0, 4))
      })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-loading-mask {
  background: transparent;
}
.bg_title_img {
  background-image: url('../../../assets/images/tab_completed.png');
}
.table_tr {
  height: 50px !important;
  margin-bottom: 7px;
  border: 1px solid #198188;
  background: rgba(24, 89, 98, 0.5);
}
.iswarn_table_tr {
  height: 50px !important;
  margin-bottom: 7px;
  border: 1px solid #f80000;
  background: rgba(163, 7, 7, 0.5);
}
.statistics_san {
  width: 96%;

  .table_bei {
    height: 20vh;
    width: 100%;
    text-align: center;
    color: #ecedee;
    font-size: 14px;
    display: inline-block;
    .table_bei td {
      text-align: left;
    }
    thead {
      width: 100%;
      height: 36px;
      display: inline-block;
    }
    tbody {
      width: 100%;
      // height: 15vh;
      height: 300px;
      overflow-y: auto;
      display: block;
    }
    thead tr {
      height: 100%;
      width: 100%;
      display: table;
      table-layout: fixed;
    }
    tbody tr {
      width: 100%;
      height: 36px; //身体部分每行的高度
      display: table;
      table-layout: fixed;
    }
  }
}
.f_bg {
  background-color: rgba(255, 137, 0, 0.4);
}
.content_relative {
  top: -10px;
}
.handle_btn {
  height: 32px;
  width: 96px;
  border-radius: 32px;
  background: linear-gradient(180deg, #137ee566 0%, #19a4da66 100%),
    linear-gradient(-180deg, #05bdff00 0%, #3bfff566 100%);
  box-shadow: inset 0px 1px 15px 0px #77c4ff33;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
}
.handle_btn[disabled] {
  cursor: no-drop;
}
.first_step_content_box,
.second_step_content_box,
.third_step_content_box {
  padding-top: 10px;
}
.first_step_content_box {
  color: #ffffff99;
  font-size: 14px;
  > span {
    color: white;
  }
  > div {
    margin-bottom: 10px;
  }
}
</style>
